import SvgGlobe from 'src/components/Common/Svgs/Globe';
import SvgPhone from 'src/components/Common/Svgs/Phone';
import { ContractorCardPropsType } from '..';
import InfoLink from './InfoLink';

type AboutPropsType = Pick<
  ContractorCardPropsType,
  'website' | 'phone' | 'additionalInformation' | 'sendContractorCardAnalytics'
>;

const About = ({
  website,
  phone,
  additionalInformation,
  sendContractorCardAnalytics,
}: AboutPropsType) => {
  // not sure if we going to need any data checking/formatting for phone and website
  return (
    <div>
      <InfoLink
        link={website}
        icon={<SvgGlobe height={'1rem'} />}
        sendContractorCardAnalytics={sendContractorCardAnalytics}
        linkType="web"
      />
      <InfoLink
        link={phone}
        icon={<SvgPhone height={'1rem'} />}
        sendContractorCardAnalytics={sendContractorCardAnalytics}
        linkType="phone"
      />
      <p className="text-gray-dark">{additionalInformation}</p>
    </div>
  );
};

export default About;
